var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-full-screen-file-drop",class:_vm.classes},[_vm._t("default",[_c('div',{staticClass:"vue-full-screen-file-drop__content"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }